import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "CreateProfile",
    component: () => (__SERVER__ ? require("./create-profile-view") : import("./create-profile-view"))
});

export default definition;
